import { DataRoomEntry } from "@/pages/OneDataRoomPage";
import { DATA_ROOM_STATIC_ID } from "../DataRoomCategoriesDefines";

export function findName(matches: DATA_ROOM_STATIC_ID[], search: string, entry: DataRoomEntry): DATA_ROOM_STATIC_ID[] | void {
  if (entry.name.toLowerCase().includes(search.toLowerCase())) {
    if (!matches.includes(entry.staticId)) {
      matches.push(entry.staticId);
    }
  }

  if (entry.entries?.length > 0) {
    entry.entries.forEach((e) => {
      const prev_len = matches.length;
      findName(matches, search, e);
      if (matches.length > prev_len && !matches.includes(e.staticId)) {
        matches.push(e.staticId);
      }
    });
  }
}
